import Button from 'components/Button';
import styled from 'styled-components';
import tw from 'twin.macro';

export const Wrapper = tw.div`w-full h-full flex justify-center items-center`;

export const SwiperItem = tw.div`w-full h-full flex flex-col gap-3 justify-center items-center relative`;

export const SwiperItemIcon = tw.img`w-[7.813rem] h-[7.563rem] object-contain`;

export const SWiperItemContent = tw.div`w-full flex flex-col justify-between gap-x-10 gap-y-4 px-8`;

export const MissionName = tw.div`flex justify-between items-center gap-1`;

export const Reward = tw.div`
   flex justify-center items-center gap-1 text-xl
   py-1 px-4 bg-gray border-[3px] border-black  rounded-3xl self-end 
`;

export const CloseButton = styled(Button)`
  ${tw`absolute -top-5 -right-4 z-10 outline-none`}
`;

export const StarButton = styled(Button)`
  ${tw`absolute -bottom-2 left-auto right-auto translate-y-1/2 [&>div]:(flex justify-center items-center gap-1) outline-none`}
`;
